module.exports = require("minimist");


//////////////////
// WEBPACK FOOTER
// external "minimist"
// module id = 98
// module chunks = 0 1 2